var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperClip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.1 16.476-7.712 7.546c-2.001 1.971-4.7 1.776-6.42.072-1.732-1.684-1.93-4.302.074-6.273L19.565 7.533c1.208-1.18 2.981-1.345 4.133-.225 1.145 1.14.977 2.864-.218 4.045L13.195 21.414c-.513.524-1.141.37-1.5.021-.356-.36-.504-.955.013-1.478l7.185-7.013c.316-.318.336-.77.034-1.068-.306-.287-.77-.267-1.081.041l-7.21 7.054c-1.07 1.047-1.027 2.649-.083 3.573 1.027 1.006 2.582.985 3.66-.072l10.324-10.103c1.964-1.92 1.88-4.445.168-6.119-1.665-1.632-4.291-1.756-6.252.164L7.877 16.774c-2.592 2.536-2.394 6.16-.054 8.45 2.34 2.279 6.044 2.474 8.636-.052l7.766-7.597c.302-.298.302-.842-.01-1.12-.306-.318-.8-.277-1.115.021z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClip);
export default __webpack_public_path__ + "static/media/Paper-Clip.25763a9d32644c5947c0bc511b091e5d.svg";
export { ForwardRef as ReactComponent };